var index = {
  root: {
    gap: '0.5rem',
    transitionDuration: '{transition.duration}'
  }
};

export { index as default };
//# sourceMappingURL=index.mjs.map
